import { Chip } from '@jotpsych/ui';
import { Stack, Tooltip, Typography } from '@mui/material';

import { isAgeActionable, STATUS_DATE_UNAVAILABLE, statusAge, statusAgeSeverity } from '../statusAge';
import type { PayerState } from '../types';

export interface StatusAgeLineProps {
  statusUpdatedAt?: string | null;
  /** Reference instant for the elapsed time; `status_updated_at` stays the anchor. */
  asOf: Date;
  /** The folded state the age belongs to; terminal/done states get plain text instead of an urgency chip. */
  state: PayerState;
}

/**
 * "since Sep 3" with the elapsed time beneath it. While the status still
 * waits on someone the elapsed time is a chip colored by how long it has
 * been; the exact zoned timestamp is on hover.
 */
export function StatusAgeLine({ statusUpdatedAt, asOf, state }: StatusAgeLineProps) {
  const age = statusAge(statusUpdatedAt, asOf);
  if (!age) {
    return (
      <Typography variant="caption" component="span" color="text.secondary" sx={{ display: 'block' }}>
        {STATUS_DATE_UNAVAILABLE}
      </Typography>
    );
  }
  return (
    <Tooltip title={age.exact}>
      <Stack spacing={0.5} sx={{ alignItems: 'flex-start' }}>
        <Typography variant="caption" component="span" color="text.secondary">
          since {age.since}
        </Typography>
        {isAgeActionable(state) ? (
          <Chip
            label={age.elapsed}
            variant="soft"
            size="xSmall"
            color={statusAgeSeverity(age.days)}
            sx={{ fontWeight: 600 }}
          />
        ) : (
          <Typography variant="caption" component="span" color="text.secondary">
            {age.elapsed}
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
}
